<!--  -->
<template>
  <div class="AnnouncementList">
    <div class="Announcement-search">
      <!-- <h1>公告从2010年9月13日起</h1> -->
      <input type="text" v-model="searchMsg" :placeholder="gjc" />
      <el-date-picker
        v-model="value1"
        type="daterange"
        unlink-panels
        value-format="yyyy-MM-dd"
        :start-placeholder="ksrq"
        :end-placeholder="jsrq"
      >
      </el-date-picker>
      <div class="serach-btn" @click="getList">
        {{ search }}
      </div>
    </div>

    <ul class="tableList">
      <li class="titleList">
        <h1>{{ rq }}</h1>
        <h2>{{ bt }}</h2>
      </li>
      <li class="dataList" v-for="(item, index) in dataList" :key="index">
        <span>{{ item.time }}</span>
        <p>{{ item.title }}</p>
        <a :href="item.pdf" target="_blank">
          <img src="../../assets/searchdown.png" />
        </a>
      </li>
    </ul>

    <div class="page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[5, 10, 20, 30]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagetotal"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      search: "", //搜索
      gjc: "",
      ksrq: "",
      jsrq: "",
      bt: "",
      rq: "",

      dataList: [
        /* 
        {
          id: "",
          time: "2021.01.12",
          title: "堃博生物科技有限公司2020年财务报告",
        },
        {
          id: "",
          time: "2021.01.12",
          title: "堃博生物科技有限公司2020年财务报告",
        },
        {
          id: "",
          time: "2021.01.12",
          title: "堃博生物科技有限公司2020年财务报告",
        },
        {
          id: "",
          time: "2021.01.12",
          title: "堃博生物科技有限公司2020年财务报告",
        },
        {
          id: "",
          time: "2021.01.12",
          title: "堃博生物科技有限公司2020年财务报告",
        },
       */
      ],
      // 搜索关键字
      searchMsg: "",
      // 选择时间
      value1: "",

      //默认第几页
      currentPage: 1,
      //总条数
      pagetotal: 0,
      //每页多少条 默认为5
      pagesize: 10,
      pagesizes: 10,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 页面初始数据获取
    getList() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "article_list",
          category_id: 17,
          key_words: that.searchMsg,
          start_date: that.value1[0],
          end_date: that.value1[1],
          show_num: that.pagesizes, //每页显示几条
          page: that.currentPage, //当前第几页
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            that.dataList = [];
            if (obj.data) {
              that.pagetotal = obj.data[0].total_nums; //总条数
              $.each(obj.data, function (i, k) {
                that.dataList.push({
                  id: k.id,
                  title: k.title,
                  time: k.create_times,
                  pdf: k.filepath,
                });
              });
            }
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
    // 搜索数据
    /* searchData(searchMsg, time) {
      console.log(searchMsg, time);
    }, */
    //切换每页显示多少条数据方法
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      //更新列表数据
      this.getList();
    },
    // 切换页数
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val
      //更新列表数据
      this.getList();
    },
    //文字翻译
    get_fanyi() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "get_fanyi",
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            that.gjc = obj.data["gjc"];
            that.ksrq = obj.data["ksrq"];
            that.jsrq = obj.data["jsrq"];
            that.search = obj.data["ss"];
            that.rq = obj.data["rq"];
            that.bt = obj.data["bt"];
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    //页面初始数据
    this.getList();
    this.get_fanyi();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
@import "../../../scss/public.scss";
.AnnouncementList {
  width: $main-width;
  margin: 0 auto;
  .Announcement-search {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    position: relative;
    h1 {
      font-size: 0.7rem;
      color: #404040;
      position: absolute;
      top: -30px;
      left: 50%;
    }
    input {
      padding: 0 50px;
      width: 230px;
      border: 2px solid #eaeaeb;
      border-radius: 23px;
      color: #404040;
      font-size: 0.9rem;
      height: 45px;
      background: url("../../assets/searchTime.png") no-repeat 20px 10px;
      margin-right: 20px;
    }
    input::-webkit-input-placeholder {
      color: #404040;
      font-size: 0.9rem;
    }
    .serach-btn {
      width: 130px;
      cursor: pointer;
      padding: 10px 0;
      text-align: center;
      background: #47aeea;
      border-radius: 23px;
      color: #fff;
      font-size: 1rem;
      margin-left: 20px;
    }
  }
  .Announcement-search >>> .el-range-editor.el-input__inner {
    border: 2px solid #eaeaeb;
    border-radius: 23px;
    height: 45px;
  }

  .tableList {
    width: 100%;
    margin: 50px 0 50px;
    .titleList {
      width: 100%;
      background: #f6f5f6;
      padding: 14px 10px;
      h1 {
        display: inline-block;
        color: #333;
        font-size: 1.2rem;
        font-weight: 400;
        width: 220px;
      }
      h2 {
        display: inline-block;
        color: #333;
        font-size: 1.2rem;
        font-weight: 400;
      }
    }

    .dataList {
      width: 100%;
      padding: 16px 10px;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #e6e6e6;
      span {
        display: inline-block;
        font-size: 1rem;
        color: #333;
        width: 220px;
        font-weight: 200;
      }
      p {
        width: 81%;
        display: inline-block;
        font-size: 1rem;
        color: #333;
        font-weight: 200;
      }
    }
  }

  .page {
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 50px 0 50px;
  }
}
@media screen and (max-width: $main-width) {
  .AnnouncementList {
    width: 100%;
    padding: 0 10px;
    .Announcement-search {
      flex-direction: column;
      input {
        margin-top: 20px;
      }
      .el-date-editor {
        width: 100%;
        margin-top: 20px;
      }
      .serach-btn {
        margin-top: 20px;
      }
    }
    .page {
      width: 100%;
      .el-pagination {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
      }
      .el-pagination >>> .el-pagination__jump {
        margin-top: 10px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/investor/AnnouncementList.vue